import { useTranslation } from '../i18n';
import { useNbTheme } from '../hooks/useNbTheme';
import ButtonNB from './ui-nb/ButtonNB';

export default function CTABandNB() {
  const { t, language } = useTranslation();
  const { theme, colors } = useNbTheme();
  const isDark = theme === 'dark';

  return (
    <section
      style={{
        background: colors.accentPrimary || '#FFD600',
      }}
    >
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-16 text-center">
        <h2
          className="font-nb font-bold text-2xl md:text-3xl mb-3"
          style={{ color: isDark ? '#0D0D0D' : '#1C1C1C' }}
        >
          {t('cta.title')}
        </h2>
        <p
          className="font-nb text-base md:text-lg mb-6 md:mb-8 max-w-xl mx-auto"
          style={{ color: isDark ? '#0D0D0D' : '#1C1C1C' }}
        >
          {t('cta.subtitle')}
        </p>
        <ButtonNB variant="primary" size="lg">
          <a href={`/${language}/register`} className="block w-full">{t('cta.cta')}</a>
        </ButtonNB>
      </div>
    </section>
  );
}
